import { useTranslation } from 'libs/i18n';
import { IconButton, Stack, Typography } from 'libs/ui';
import { Icon } from 'libs/ui/Icon';

interface Props {
  index: number;
  readOnly?: boolean;
  onRemove: (index: number) => void;
}

export const Header = ({ index, onRemove, readOnly }: Props) => {
  const { t } = useTranslation();
  return (
    <Stack alignItems="center" direction="row" spacing={12}>
      <Typography variant="bodyBold">
        {t(
          index === 0
            ? 'client.legal.companyOrderSubmissionContacts.contactHeader'
            : 'client.legal.companyOrderSubmissionContacts.contactHeaderOther'
        )}
      </Typography>
      {!readOnly && index !== 0 && (
        <IconButton
          colorVariant="red"
          icon={<Icon.Minus size={16} />}
          mode="outlined"
          sizeVariant="xs"
          onClick={() => onRemove(index)}
        />
      )}
    </Stack>
  );
};
